import React, { Component } from 'react';
import datetimeDifference from "../../helpers/datetime-difference";
import date2obj from '../../helpers/date2obj';
import { Icon, Grid, Image } from 'semantic-ui-react';
import './GanttChart.css';
import diamond from "./../../images/grafix-icon/diamond.svg";
import { DateTime } from "luxon";
import EllipsisTooltip from './EllipsisTooltip';
import ImageAvater from '../drive/Components/ImageAvater';

/*
        0  1    2   3   4    5  6
      [sun,mon,tue,wed,thus,fri,sat]

      x-1 

      [mon,tue,wed,thus,fri,sat,sun]

*/

const calculateDatesBetween = function (projectStartDate, projectEndDate) {

  const datesData = [];

  let startDate = projectStartDate.endOf('day');
  const endDate = projectEndDate.endOf('day');

  while (startDate <= endDate) {
    const currentDay = new Date(startDate.year, startDate.month - 1, startDate.day);
    datesData.push(currentDay);
    startDate = startDate.plus({ days: 1 });
  }

  return datesData;

}

const monthsFull = ["January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"];

const monthsShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class GanttChart extends Component {

  constructor(props) {
    super(props);
    this.state = { hovering: false }
  }

  mouseOver = (e) => {

    const activityId = e.target.getAttribute("data-activity");
    const xPosition = e.pageX;
    const yPosition = e.pageY;
    const windowsWidth = window.innerWidth;
    const windowsHeight = window.innerHeight;
    e.stopPropagation();
    this.setState({
      hovering: true,
      xPosition,
      yPosition,
      windowsWidth,
      activityId,
      windowsHeight
    });
  }

  mouseOut = (e) => {
    this.setState({ hovering: false });
  }

  render() {

    if (this.props.activeIndex !== 0) {
      return null;
    }

    const timeZone = this.props.timeZone;

    const projectStartDate = DateTime.fromFormat(this.props.projectStartDate, 'LL-dd-yyyy').setZone(timeZone).startOf('day');
    const projectEndDate = DateTime.fromFormat(this.props.projectEndDate, 'LL-dd-yyyy').setZone(timeZone).endOf('day');

    const projectDates = calculateDatesBetween(projectStartDate, projectEndDate);

    const activities = this.props.projectDetails.activities;
    const workingDays = this.props.projectDetails.workingDays;
    const datesArray = [];
    const monthsData = {}

    const thisObject = this;

    for (const date of projectDates) {
      let dateObj = date2obj(date, {
        fields: ['year', 'month', 'day']
      });
      const month = monthsFull[dateObj.month - 1];
      if (monthsData[month]) {
        monthsData[month].count++
      } else {
        monthsData[month] = {
          count: 1,
          year: dateObj.year
        };
      }

      let dayIndex = date.getDay();
      dateObj.isWorkingDay = workingDays && workingDays[dayIndex];
      dateObj.date = date;

      datesArray.push(dateObj);
    }

    const daysItems = datesArray.map((dateObj, index) => {
      const monthStr = monthsShort[parseInt(dateObj.month - 1, 10)];
      const dateStr = `${dateObj.day} ${monthStr}`;
      let backgroundColor = "#fff";
      if (!dateObj.isWorkingDay) {
        backgroundColor = "#f4f8ff";
      }
      const dateStyle = {
        backgroundColor: backgroundColor,
        minWidth: '80px'
      }
      return (
        <th key={index} scope="col" style={dateStyle} className="gantt-h">{dateStr}</th>
      )
    });

    const monthsItems = Object.keys(monthsData).map(function (monthKey, index) {
      const monthObj = monthsData[monthKey];
      const monthStr = `${monthKey} ${monthObj.year}`
      return (
        <th key={index} scope="col" className="gantt-h" colSpan={monthObj.count}>{monthStr}</th>
      )
    });

    const getDaysItemsForActivity = function (activity, activityIndex) {
      const columns = datesArray.map((dateObj, index) => {
        const monthStr = monthsShort[parseInt(dateObj.month - 1, 10)];
        const dateStr = `${dateObj.day} ${monthStr}`;
        let backgroundColor = "#fff";
        if (!dateObj.isWorkingDay) {
          backgroundColor = "#f4f8ff";
        }
        const dateStyle = {
          backgroundColor: backgroundColor
        }

        //activity progress bar is included in the first row
        if (index === 0) {

          let leftOffset = -10;

          const activityStartDate = new Date(activity.expectedStartDate);
          const startDiff = datetimeDifference(activityStartDate, projectStartDate.toJSDate());
          if (startDiff) {
            leftOffset = 80 * startDiff - 10;
          }

          const activityEndDate = new Date(activity.expectedEndDate);
          let rightOffset = 80 * (datetimeDifference(activityEndDate, activityStartDate));

          if (activity.isMilestone && activity.duration === 0) {
            rightOffset = 10;
          }

          const barStyle = {
            width: `${rightOffset}px`,
            left: `${leftOffset}px`,
          }

          const taskBarStyle = {
            width: `${rightOffset}px`,
            height: activity.isLeaf ? "20px" : "2px",
            background: activity.isLeaf ? "#93baec" : "#93baec",
            borderRadius: activity.isLeaf ? "4px" : "none",
            marginTop: activity.isLeaf ? "-2px" : "4px",
          }


          if (activity.isMilestone && activity.duration === 0) {
            taskBarStyle.background = "#606060";
            taskBarStyle.borderRadius = "4px";
            if (projectEndDate.toMillis() === activityEndDate.getTime() -1) {
              taskBarStyle.marginLeft = "-10px";
            }
          }

          const getTaskEdges = function () {
            if (activity.isLeaf) {
              return null
            } else {
              return (
                <React.Fragment>
                  <div className="ggroupblackendpointleft"></div>
                  <div className="ggroupblackendpointright"></div>
                </React.Fragment>
              )
            }
          }

          let popupComponent = null;
          const topPosition = thisObject.state.windowsHeight < thisObject.state.yPosition + 50 ? thisObject.state.yPosition - 100 : thisObject.state.yPosition - 30;
          const arrangePosition = thisObject.state.windowsWidth < thisObject.state.xPosition + 300 ? thisObject.state.xPosition - 270 : thisObject.state.xPosition + 20

          if (thisObject.state.hovering) {
            if (thisObject.state.activityId === activity._id) {
              popupComponent = <div className="JSGanttToolTip" style={{ left: arrangePosition, top: topPosition }}>

                <div
                  className={` activityCard cursor-pointer`} style={{ borderLeft: `4px solid ${activity.tagColor}`, width: "250px", whiteSpace: "normal", height: '84px' }} >
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={12}>
                        <div className="activityName break-two-line"   >
                          <span>{activity.name}</span>
                        </div>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        {activity.isMilestone ? <img src={diamond} className="pull-right" name="diamond" style={{ 'height': '16px', padding: "0 1px" }} alt='' /> : ""}
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={14}>
                        <ImageAvater user={activity} />
                        <span > {activity.accountable} <br />  </span>
                        <span style={{ fontSize: "9px" }}> {activity.duration ? activity.duration : 0} {activity.duration === 1 ? "day" : "days"} </span>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
              </div >
            }
          }

          return (
            <td key={index} data-row="2" style={dateStyle} data-date={dateStr}>
              <div onMouseOver={thisObject.mouseOver}
                onMouseOut={thisObject.mouseOut} className="gtaskcelldiv">&nbsp;&nbsp;
                <div id="embedded-Ganttbardiv_1159" data-activity={activity._id} className="gtaskbarcontainer" style={barStyle}>
                  <div id="embedded-Gantttaskbar_1159" data-activity={activity._id} className="gtaskbar" style={taskBarStyle}></div>
                  {getTaskEdges()}
                </div>
                {popupComponent}
              </div>
            </td>
          )
        } else {
          return (
            <td key={index} data-row="2" style={dateStyle} data-date={dateStr}></td>
          )
        }

      });
      return columns;
    }

    const getActivityColumn = function (activity) {
      const paddingLeft = (20 * activity.depth + 7);
      if (activity.isLeaf) {
        return (
          <div className="display-block float-left w_100" style={{ paddingLeft: paddingLeft + "px" }} >
            <Icon disabled name='file' className="float-left" style={{ width: '12px' }} />
            <EllipsisTooltip
              style={{ width: `${260 - paddingLeft}` }}
              name={<span> {activity.name}</span>} />
          </div>
        )
      } else {
        return (
          <div className="display-block float-left  w_100" style={{ paddingLeft: paddingLeft }}>
            <Icon disabled className="float-left" name='minus square outline' style={{ width: '12px' }} />
            <EllipsisTooltip
              style={{ width: `${260 - paddingLeft}` }}
              name={<span>{activity.name}</span>} />
          </div>
        )
      }
    }

    const getActivityData = function (activity, index) {

      return (
        <tr key={index}>
          <th style={{ paddingRight: "10px", textAlign: "left", display: 'flex', width: "300px" }}>{getActivityColumn(activity)}</th>
          {getDaysItemsForActivity(activity, index)}
        </tr>
      );
    }

    const allActivitiesArray = [];

    const getActivitiesArray = function (activityDetails, depth) {
      const activityObject = {
        _id: activityDetails._id,
        name: activityDetails.name,
        expectedStartDate: activityDetails.expectedStartDate,
        expectedEndDate: activityDetails.expectedEndDate,
        duration: activityDetails.duration ? activityDetails.duration : 0,
        isMilestone: activityDetails.isMilestone,
        depth: depth,
        tagColor: activityDetails.tagColor,
        accountable: activityDetails.accountable,
        profilePic: activityDetails.profilePic,
        firstName: activityDetails.firstName,
        lastName: activityDetails.lastName
      }

      allActivitiesArray.push(activityObject);
      if (activityDetails.activities && activityDetails.activities.length) {
        activityObject.isLeaf = false;
        activityDetails.activities.forEach(function (activity) {
          getActivitiesArray(activity, depth + 1);
        });
      } else {
        activityObject.isLeaf = true;
      }
    }

    activities.forEach(function (activity) {
      getActivitiesArray(activity, 0);
    });

    const allActivitiesRows = allActivitiesArray.map(function (activity, index) {
      return (getActivityData(activity, index))
    })

    return (
      <div id="table-scroll" className="table-scroll" style={{ width: this.props.windowDimension.width - 80, minHeight: this.props.windowHeight ? this.props.windowHeight : 300, maxHeight: this.props.windowHeight ? this.props.windowHeight : 300 }} >
        <table id="main-table" className="main-table">
          <thead>
            <tr>
              <th scope="col">&nbsp;</th>
              {monthsItems}
            </tr>
          </thead>
          <thead>
            <tr>
              <th scope="col" style={{ paddingRight: "10px", textAlign: "left", display: 'flex', width: "300px" }}>Initiative Activities</th>
              {daysItems}
            </tr>
          </thead>
        </table>
        <table>
          <tbody>
            {allActivitiesRows}
          </tbody>
        </table>
      </div>
    );
  }
}

export default GanttChart;
